<div class="closeicon pointer-hover" (click)="dialogRef.close()">
    <svg id="Group_18511" data-name="Group 18511" xmlns="http://www.w3.org/2000/svg" width="23.808" height="23.808"
        viewBox="0 0 23.808 23.808">
        <defs>
            <style>
                .cls-1 {
                    fill: rgba(0, 0, 0, 0.4);
                }

                .cls-2 {
                    fill: none;
                    stroke: black;
                    stroke-linecap: round;
                    stroke-width: 3px;
                }
            </style>
        </defs>
        <g id="Group_18510" data-name="Group 18510" transform="translate(7.383 7.614)">
            <line id="Line_1047" data-name="Line 1047" class="cls-2" x2="9.416" y2="9.416"
                transform="translate(0.081 0.085)" />
            <line id="Line_1048" data-name="Line 1048" class="cls-2" x2="9.416" y2="9.416"
                transform="matrix(0.017, 1, -1, 0.017, 9.415, 0)" />
        </g>
    </svg>

</div>

<div class="sum-container">
    <div class="errorTitle">{{title}}</div>
    <div class="center f-14 error-text">
        {{textData}}
    </div>
    <div class="btn-fix-container center">
        <button type="button" class="btn btn-primary btnconfirm btn-single" (click)="dialogRef.close()">
            OK
        </button>
    </div>
</div>